module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwBAMAAAC2+6RAAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACXRSTlMAz4BgECDfMO/59Kg5AAAAiUlEQVQ4y+3LsQ3CQBQE0ZOgCC6jDUJHpDTh3BSByAkQ2y0cWJpgfgd4kt3ktS3l9pfmzutOcwEOy2/703TKfd3Mgj2vL+2J6AfkNs4pUGByHG+XQIGPcaCGUEOooaggVBAqaAo0BZoCTYGmwJICTYEFvQJNAzQFmgJNgSUFmgJLCjQFFi3tH3sD+o1vZscHIscAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/006.png
// module id = MkxJ
// module chunks = 1